import React, { useState } from 'react';
import { Account } from '../../../types';
import { EditAccountGroupsPage } from './EditAccountGroupsPage';
import { withFetcher } from 'components/shared/hoc/withFetcher';
import { getAdministrationAccountDetails } from 'RestAPIs/admin';

const EnchantedEditAccountGroupsPage = withFetcher({
  WrappedComponent: EditAccountGroupsPage,
  fetchFunction: getAdministrationAccountDetails,
  queryKey: ['account', 'details']
});

interface Props {
  selectedAccount: Account;
  toggleInnerLayout: () => void;
  accounts: Account[];
}

export const EditAccountGroups: React.FC<Props> = ({
  selectedAccount,
  toggleInnerLayout,
  accounts
}) => {
  const [currentViewData, setCurrentViewData] = useState(selectedAccount);

  return (
    <EnchantedEditAccountGroupsPage
      id={currentViewData.accountId}
      accounts={accounts}
      currentViewData={currentViewData}
      setCurrentViewData={setCurrentViewData}
      toggleInnerLayout={toggleInnerLayout}
    />
  );
};
